import { useSelector } from 'react-redux'

export const usePricePredictionEligibility = (hasRecommendationText = false) => {
  const tripType = useSelector((state) => state?.pclnBootstrapData?.searchRequest?.params?.tripType)
  const isNotReshopAndWLAndPackages = useSelector(
    (state) => state?.pclnBootstrapData?.isNotReshopAndWLAndPackages
  )
  const hasListings = useSelector((state) => state.listings?.response?.length > 0)

  const isOW = tripType === 'OW'
  const isRT = tripType === 'RT'

  return {
    isPricePredictionEligible: isNotReshopAndWLAndPackages && (isOW || isRT) && hasListings,
    shouldShowPricePrediction:
      (isOW || isRT) && isNotReshopAndWLAndPackages && hasRecommendationText && hasListings,
  }
}
